<style scoped>
    @import url("../../../styles/smartControl/formPeriodoOff.scss");
</style>

<template>
    <div class="box_formPeriodoOff">

        <div class="mainTit mb-2">
            <span>Edição período de suspensão de irrigação automática</span>
        </div>

        <div class="menuForm">

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Status:</span>
                <div class="ml-2 elSelect">
                    <v-autocomplete
                    v-model="formLocal.status"
                    :items="liStatus"
                    color="rgb(247,215,46)"
                    class="w-100"
                    variant="plain"
                    bg-color="transparent"
                    @update:modelValue="trocarStatus(formLocal.status)"
                    placeholder="Ligado"
                    ></v-autocomplete>
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Título Atuador/setor:</span>
                <div class="ml-2 elSelect">
                    {{ formLocal.atuador }}
                </div>
            </div>
            
            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Dispositivo:</span>
                <div class="ml-2 elSelect">
                    {{ formLocal.controlador }}
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Data de início:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Hora de início:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_init"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Data de fim:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.dt_str_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="01/01/2001"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>

            <div class="linhaForm" :style="{'flex-wrap':flagStrWrap}">
                <span class="tLinha">Hora de fim:</span>
                <div class="ml-2 elInput">
                    <v-text-field
                        v-model="formLocal.hhmm_end"
                        class="w-100"
                        color="rgb(247,215,46)"
                        variant="plain"
                        bg-color="transparent"
                        placeholder="00:01"
                        @change="atualizarFormulario()"
                    />
                    <!-- :placeholder="formLocal.minutos" -->
                </div>
            </div>
        </div>

        <div class="colBtnEnd">
            <v-btn @click="addExtIrrig()" v-if="!flagMsgErro"
            class="mt-2"
            block 
            :style="{'background':'#f39c12','color':'white','white-space':'normal !important'}"
            >atualizar</v-btn>

            <v-btn @click="cancelEdit()" v-if="!flagMsgErro"
            class="mt-2 mb-2"
            block 
            :style="{'background':'white','color':'#f39c12','white-space':'normal !important'}"
            >cancelar edição</v-btn>

            <div v-if="flagMsgErro" class="mt-1" :style="{'align-self':'center','color':'white','font-size':'0.8rem','font-weight':'100'}">{{ msgErro }}</div>
        </div>

    </div>
</template>

<script>
import { convToUtc } from "../auxSC/timeConv.js"; // criado em 01/06/2026

export default {

    props:['infoP','flagStrWrap'],

    data() {
        return {

            // -- default form
            formLocal: {
                'tit':'',
                'status':'Desligado',
                'dt_str_init':'01/01/2001',
                'hhmm_init':'05:01',
                'dt_str_end':'01/01/2001',
                'hhmm_end':'06:01',
                'controlador':'',
                'atuador':'',
                'device_id':'',
            },

            // -- handle atuadores.
            liStatus:['Ligado','Desligado'],

            // -- handle btn.
            flagMsgErro:false,
            msgErro:'Preencha corretamente todos os campos.',
        }
    },

    methods:{

        cancelEdit() { this.$emit('cancelEdit', false) },

        addExtIrrig() { 

            // -- validar form.

            //console.log('formLocal: ',this.formLocal)

            const device_ctrl = this.formLocal['controlador']
            const device_atuador = this.formLocal['atuador']
            const device_id = this.formLocal['device_id']
            if (device_ctrl == '' || device_atuador == '' || device_id == '') {
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                console.log('erro 1')
                return 
            }
            else { this.flagMsgErro = false }

            // -- validação do formato da data do input.
            const flag_hhmm_e_dtStr_ok = this.atualizarFormulario()
            if (flag_hhmm_e_dtStr_ok == false) { 
                this.msgErro = 'Preencha corretamente todos os campos.'
                this.flagMsgErro = true; 
                console.log('erro 1')
                return 
            }
            else { this.flagMsgErro = false }

            // -- converter horário local para utc nos dois formatos.
            const hhmmLocal_init = this.formLocal['hhmm_init']
            const dataStr_init = this.formLocal['dt_str_init']
            const hhmmLocal_end = this.formLocal['hhmm_end']
            const dataStr_end = this.formLocal['dt_str_end']
            
            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
            
            const utcInit = convToUtc(dataStr_init, hhmmLocal_init, tzName)
            const utcEnd = convToUtc(dataStr_end, hhmmLocal_end, tzName)

            const hhmmUTC_init = utcInit.hhmmUtc
            const dataStrUTC_init = utcInit.dataUtcStr
            const dt_init = utcInit.isoUtc

            const hhmmUTC_end = utcEnd.hhmmUtc
            const dataStrUTC_end = utcEnd.dataUtcStr
            const dt_end = utcEnd.isoUtc

            const dt_str_init = `${dataStrUTC_init}-${hhmmUTC_init}` // problema com dt na virada do dia ??
            const dt_str_end = `${dataStrUTC_end}-${hhmmUTC_end}` // problema com dt na virada do dia ??

            // -- nota final (se estiver vazia).
            if (this.formLocal['nota'] == '') { this.formLocal['nota'] == 'Irrigação externa feita pelo Cliente' }

            // 
            let status = (this.formLocal['status'] == 'Ligado') ? 'on' : 'off';

            //
            const dt_edit = new Date().toISOString()

            let endForm = {
                
                'received_at':dt_edit, // dt utc
                
                'utc_rega_off_init':dt_init, // dt utc
                'utc_rega_off_end':dt_end, // dt utc
                
                'dt_str_init':dt_str_init, // string utc
                'dt_str_end':dt_str_end, // string utc
                
                'device_id':device_id, // irrig externoa associada ao device_id do atuador do setor
                'setor_atuador':device_atuador,
                
                'status':status
            }

            // -- emitir input endForm.
            this.$emit('fromChild2edit', endForm) // dict input_last_info
            //console.log('endForm: ',endForm)
        },

        atualizarFormulario() {

            //console.log('formLocal: ',this.formLocal)

            // -- verificação se o momento da irrigação está no formato correto.
            const flag_fmt_hhmm_init = this.validarHoraHhmm(this.formLocal['hhmm_init'])
            const flag_fmt_dtStr_init = this.validarDataDdMmAaaa(this.formLocal['dt_str_init'])
            const flag_fmt_hhmm_end = this.validarHoraHhmm(this.formLocal['hhmm_end'])
            const flag_fmt_dtStr_end = this.validarDataDdMmAaaa(this.formLocal['dt_str_end'])

            if (flag_fmt_hhmm_init && flag_fmt_dtStr_init && flag_fmt_hhmm_end && flag_fmt_dtStr_end) { 

                this.flagMsgErro = false // reset msg erro (se houver)
                return true
            }
            else { 

                this.flagMsgErro = true // habilitar msg erro
                this.msgErro = 'Formatos 01/01/2001 e 00:02 obrigatório.'
                this.formLocal['hhmm'] = '05:02' // reset para o fmt correto
                this.formLocal['dt_str'] = '01/01/2001' // reset para o fmt correto
                return false
            }
        },

        validarHoraHhmm(valor) {
            const regex = /^(\d{2}):(\d{2})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const hora = parseInt(match[1], 10);
            const minuto = parseInt(match[2], 10);

            return (
                hora >= 0 &&
                hora <= 23 &&
                minuto >= 0 &&
                minuto <= 59
            );
        },

        validarDataDdMmAaaa(valor) {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = valor.match(regex);

            if (!match) return false;

            const dia = parseInt(match[1], 10);
            const mes = parseInt(match[2], 10);
            const ano = parseInt(match[3], 10);

            if (mes < 1 || mes > 12) return false;

            const dt = new Date(ano, mes - 1, dia);

            return (
                dt.getFullYear() === ano &&
                dt.getMonth() === mes - 1 &&
                dt.getDate() === dia
            );
        },

        convStrToDt(dateHrUtc) {
            const [data, hora] = dateHrUtc.split("-");
            const [dia, mes, ano] = data.split("/").map(Number);
            const [hh, mm] = hora.split(":").map(Number);

            return new Date(Date.UTC(ano, mes - 1, dia, hh, mm));
        },

        trocarStatus(statusSelected) {
            console.log('statusSelected: ',statusSelected)
            this.formLocal['status'] = statusSelected
        },

        init() {
            // -- Edição disponível por atuador: ON/OFF, início e fim.
            if (this.infoP.status == 'on') { this.formLocal['status'] = 'Ligado' } else { this.formLocal['status'] = 'Desligado' }
            this.formLocal['controlador'] = this.infoP.controlador
            this.formLocal['atuador'] = this.infoP.atuador
            this.formLocal['device_id'] = this.infoP.device_id
            if (this.infoP.dt_str_init != '') { this.formLocal['dt_str_init'] = this.infoP.dt_str_init }
            if (this.infoP.hhmm_init != '') { this.formLocal['hhmm_init'] = this.infoP.hhmm_init }
            if (this.infoP.dt_str_end != '') { this.formLocal['dt_str_end'] = this.infoP.dt_str_end }
            if (this.infoP.hhmm_end != '') { this.formLocal['hhmm_end'] = this.infoP.hhmm_end }

            //console.log('this.formLocal: ',this.formLocal)
        },
    },

    created() {
        //window.scrollTo(0,0)
        this.init()
    }
}
</script>
